import React from "react";
import EmfUsage from "components/app/report/environment/emfUsage/EmfUsage";

type ScreenEmfUsageProps = React.PropsWithChildren<{}>;

function ScreenEmfUsage(props: ScreenEmfUsageProps) {
	return <EmfUsage />;
}

export default ScreenEmfUsage;
